import(/* webpackMode: "eager" */ "/home/node/build/node_modules/next/dist/client/link.js");
